/**
 * uid:string 用户身份id
 * page:string 页
 * kw:string 搜索关键词
 */

const api = new Proxy(
{   
    /** 获取地区 {no_group:1,is_no:1,id:string} */
    getAreas: '/app/area/getAreaOneLevels',
    /** 获取验证码 {phone:number} */
    getSmsCode: '/api/index/getSmsCode',
    /** 校验验证码 {phone:number,code:number} */
    checkCode: '/api/index/checkCode',
    /** 新校验验证码 {phone:number,code:number} */
    checkCodeOnly: '/api/index/checkCodeOnly',
    /** 注册 post {phoen,pwd} */
    regis: '/api/index/regis',
    /** 忘记密码 post {phoen,pwd} */
    editPwd: '/api/index/editPwd',
    /** 登录 post {phoen,pwd} */
    login: '/api/index/login',
        /** 获取用户信息 {uid:string} */
    getUserInfo: '/api/index/getUserInfo',
    /** 修改用户信息 method:post {id:string,logo:string,name:string,note:string} */
    editUser: '/api/index/editUser',
    /** 主页信息 response {banner hot推荐 tonglan通栏广告 videos视频 audios 音频 txts 文稿 rank排行} */
    home: '/api/index/home',
    /** 全局config  response {
     * free_num 免费音视频转化次数
     * given_coins 新用户注册赠送金币数量
     * per_coins 下载档案用户获得金币占比
     * title 页面标题
     * descp 页面描述
     * keys 页面关键词
     * footer 版权文案
     * info_no_pic 档案缺省图
     * user_no_pic 用户默认头像
     * jb_qr_wx 金币支付微信二维码
     * jb_qr_zfb 金币支付支付宝二维码
} */
    config: '/api/index/config',
    /** 相册 {page:number,did:string} */
    daPicList: '/api/index/daPicList',
    /** 列表{
     * page:number=1,
     * kw:string='',
     * type:string='0', 类型
     * topic:string='0', 主题
     * job:string= '0',  职业
     * sex:string='0', 性别
     * province:string='0', 省
     * city:string='0', 城市
     * sort?:string='0', 0默认 1倒序
     * uid:sring='0',
     * save_uid:string='0', 我收藏的
     * save_doc_id:string=0, 收藏夹id 
     * download_uid?:string=0 我下载的
     * } */
     daList: '/api/index/daList',
     /** 观看记录{page:string=1,uid:string} */
     log: '/api/index/log',
     /** 我的关注 {page:string=1,uid:string,sdid:string=0} */
     myFollow: '/api/index/myFollow',
     /** 详情页 {id:string=0,uid:string}
      * response {
      *     id,title,hits点击量,time,topic,type,area,
      *     descp描述,url 音视频文稿地址,
      *     content正文,dz点赞数,xz下载数,
      *     is_dz我是否点赞,
      *     is_sc 我是否收藏
      *     is_xz 我是否下载
      *     author: { id,name,logo,is_follow:-1没登入不能关注,fs,dz }
      *     imgs 相册,
      * }
      */
     daInfo: '/api/index/daInfo',
     /** 关注 {uid:string,id:string,sdid:string} sdis文件夹id */
     setFollow: '/api/index/setFollow',
     /** 收藏 {uid:string,id:string,sdid:string} */
     setSave: '/api/index/setSave',
     /** 下载 { uid:string,id:string } */
     download: '/api/index/download',
     /** 点赞 {uid:string,id:string,type:string=0档案,1用户} */
     setPraise: '/api/index/setPraise',
     /** 关注文件夹 {uid:string} */
     getFollowDoc: '/api/index/getFollowDoc',
     /** 收藏文件夹 {uid:string} */
     getSaveDoc: '/api/index/getSaveDoc',
     /** 创建关注文件夹 {uid:string,name:string} */
     createFollowDoc: '/api/index/createFollowDoc',
     /** 创建收藏文件夹 {uid:string,name:string} */
     createSaveDoc: '/api/index/createSaveDoc',
     /** 编辑文件夹 {id:string,name:string} */
     editDoc: '/api/index/editDoc',
     /** 删除文件夹 {id:string} */
     delDoc: '/api/index/delDoc',
     /** 新增档案 methods:post {
      * id,topic,type,job,sex,area,province,uid,url,fm,title,descp,content,
      * tags: 字符串数组 tags[],imgs json字符串数组
      * } */
    addDa: '/api/index/addDa',
    /** 获取标签 {type topic job sex} */
    getTags: '/api/index/getTags',
    /** 帖子 {page:string,uid:string,kw:string} */  
    tzList: '/api/index/tzList',
    /** 评论列表 {page,uid,kw} */  
    replayList: '/api/index/replyList',
    /** 帖子详情{id:string,uid} */
    tzInfo: '/api/index/tzInfo',
    /** 添加帖子 methods:post {uid,title,content} */
    addTz: '/api/index/addTz',
    /** 添加评论 methods:post {uid,eid:string 帖子id,content:string} */
    addReply: '/api/index/addReply',
    /** 删除帖子{id:string} */
    delTz: '/api/index/delTz',
    /** 删除评论{id:string} */
    delReply: '/api/index/delReply',
    /** 七牛获取token */
    getQiNiuToken: '/api/image/qnUpload',
    getQiNiuCoverToken: '/api/image/qnUploadNoKey',
    /** url */
    adudioToWord: '/api/index/audio',
    /**  没有次数是否可以音频视频转文字 {uid}  */
    getCanAudio: '/api/index/getCanAudio',
},
{
    get(target, key, content){
        return Reflect.get(target, key)
    },
    set(oTarget, sKey, vValue){
        throw new Error('API are readyonly')
    },
    deleteProperty(){
        throw new Error('API methods cannot be deleted!');
    }
})
// 评论列表缺少帖子id 获取地区404   列表sex 不对 分类中没有不限  收藏夹对应切换 关注和收藏没有默认  // 关注列表人的关注与取关 没有判断   视频详举报
export default  api